module.exports = __webpack_public_path__ + "static/media/igd-logo.33aabc88.png";